import { useIsClient } from '@utils/common';

import { useIsAuthQuery } from './graphql.v4.generated';

export const useIsAuth = () => {
  const client = useIsClient();
  const { data, loading } = useIsAuthQuery({
    context: {
      v4: true,
      ignoreAuthError: true,
    },
    skip: !client,
  });

  if (loading) {
    return null;
  }

  return !!data?.viewer;
};
